<template>
  <v-avatar class="e-avatar" :size="computedSize" :class="sizeableClasses">
    <v-img v-if="src" :src="src">
      <template #placeholder>
        <div class="e-avatar__default-image">
          <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_827_20305)">
              <rect width="18" height="18" rx="9" fill="#E4F1FF" />
              <path
                d="M8.99999 12.6615C4.4813 12.6615 0.818176 16.2238 0.818176 20.6182H17.1818C17.1818 16.2238 13.5187 12.6615 8.99999 12.6615Z"
                fill="#489FFE"
              />
              <ellipse cx="8.91897" cy="7.01232" rx="3.88839" ry="3.73962" fill="#489FFE" />
            </g>
            <defs>
              <clipPath id="clip0_827_20305">
                <rect width="18" height="18" rx="9" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </template>
    </v-img>
    <div v-else class="e-avatar__no-image" :style="{ background: letters || icon ? color : 'transparent' }">
      <div class="e-avatar__letters" v-if="letters">{{ letters }}</div>
      <div class="e-avatar__icon" v-else-if="icon">
        <v-icon :size="computedIconSize">{{ icon }}</v-icon>
      </div>
      <div v-else class="e-avatar__default-image">
        <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_827_20305)">
            <rect width="18" height="18" rx="9" fill="#E4F1FF" />
            <path
              d="M8.99999 12.6615C4.4813 12.6615 0.818176 16.2238 0.818176 20.6182H17.1818C17.1818 16.2238 13.5187 12.6615 8.99999 12.6615Z"
              fill="#489FFE"
            />
            <ellipse cx="8.91897" cy="7.01232" rx="3.88839" ry="3.73962" fill="#489FFE" />
          </g>
          <defs>
            <clipPath id="clip0_827_20305">
              <rect width="18" height="18" rx="9" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  </v-avatar>
</template>

<script>
import { VImg, VAvatar, VIcon, VProgressCircular, VRow } from 'vuetify/lib'
import Sizeable from '../../mixins/sizeable'

export default {
  name: 'EAvatar',
  components: { VImg, VAvatar, VIcon, VProgressCircular, VRow },
  mixins: [Sizeable],
  props: {
    src: {
      type: String,
      default: undefined,
    },
    letters: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    xSmall: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    xLarge: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#94BAC3',
    },
  },
  computed: {
    computedSize() {
      return this.xSmall ? 18 : this.small ? 28 : this.large ? 44 : this.xLarge ? 64 : 36
    },
    computedIconSize() {
      return this.xSmall ? 10 : this.small ? 14 : this.large ? 24 : this.xLarge ? 28 : 18
    },
  },
  methods: {},
}
</script>
